import { Image, Text } from '@vinted/web-ui'

import type { ABTestConfig } from '../components/PhishingFirstTimeListerEducation/Slides/newContentTestConfig'

export const getDurationForExample = (
  slideIndex: number,
  exampleIndex: number,
  config: ABTestConfig,
): number => {
  const durations = config.exampleDurations[slideIndex]

  return durations?.[exampleIndex] || 3000
}

export const formatMessages = (
  messages: Array<string>,
  translate: (key: string) => string,
  asset: (path: string) => string,
) =>
  messages.map(message => {
    if (message.includes('.png')) {
      return <Image key={message} src={asset(message)} size={Image.Size.X2Large} />
    }

    return (
      <Text
        key={message}
        as="span"
        text={translate(message)}
        type={Text.Type.Body}
        alignment={Text.Alignment.Left}
        html
      />
    )
  })

export const getButtonTranslationKey = (
  isEducationStarted: boolean,
  isLastSlide: boolean,
  config: ABTestConfig,
): string => {
  if (!isEducationStarted) return config.buttonTranslations.intro
  if (isLastSlide) return config.buttonTranslations.close

  return 'actions.next'
}
